export enum PoiValidatorsVehicleType{
    company = 1,
    personal = 2
}